import { render, staticRenderFns } from "./Verificationv2.vue?vue&type=template&id=0dbddaf0&scoped=true&"
import script from "./Verificationv2.vue?vue&type=script&lang=js&"
export * from "./Verificationv2.vue?vue&type=script&lang=js&"
import style0 from "./Verificationv2.vue?vue&type=style&index=0&id=0dbddaf0&prod&lang=scss&scoped=true&"
import style1 from "./Verificationv2.vue?vue&type=style&index=1&id=0dbddaf0&prod&lang=css&"
import style2 from "./Verificationv2.vue?vue&type=style&index=2&id=0dbddaf0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dbddaf0",
  null
  
)

export default component.exports